import { createContext } from 'react';

const FontSizeMultiplierContext = createContext(100);

export default FontSizeMultiplierContext;
